import { MultipleChoiceScore } from '../../MultipleChoice/modules/MultipleChoiceScore';
export class CorrectWrongScore extends MultipleChoiceScore {
    get question() {
        return this.parent;
    }
    get legacyEvalText() {
        return this.question.options[0].isSelected ? '1' : '0';
    }
    set legacyEvalText(t) {
        this.question.options[0].isSelected = t === '0';
        this.question.options[1].isSelected = t === '1';
    }
}
